import React from 'react'
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  Stack,
  TextField,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

export default function VehiculoFormDialog({
  open,
  onClose,
  title = 'Nuevo vehículo',
  submitLabel = 'Crear vehículo',
  form,
  onChange,
  onSubmit,
  error,
  loading = false,
}) {
  const disabled = Boolean(loading)
  const isValid = Boolean(String(form.modelo || '').trim())

  const handleSubmit = (event) => {
    event?.preventDefault?.()
    if (!isValid || disabled) return
    onSubmit?.(event)
  }

  return (
    <Dialog open={open} onClose={disabled ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box component="span" sx={{ fontWeight: 700 }}>{title}</Box>
          <IconButton aria-label="close" onClick={onClose} size="small" disabled={disabled}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      {loading && <LinearProgress />}

      <DialogContent>
        <Stack spacing={2} sx={{ mb: 2 }}>
          {error && <Alert severity="error">{error}</Alert>}
        </Stack>

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            label="Vehículo"
            fullWidth
            name="modelo"
            value={form.modelo}
            onChange={onChange}
            disabled={disabled}
            required
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ pr: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={disabled} color="inherit">Cancelar</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={disabled || !isValid}>
          {loading ? 'Guardando...' : submitLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
